import { SxProps, Theme } from "@mui/material";

export const topPerformersCardStyle: SxProps<Theme> = (theme) => ({
  borderRadius: "14px",
  border: `1px solid ${theme.palette.quizPopap.quizSeparator}`,
  backgroundColor: theme.palette.mode === "dark" ? "#181E2D" : "#FFFFFF",
  p: { xs: 1.2, md: 1.4 },
  minHeight: { xs: "auto", md: 200 },
  display: "flex",
  flexDirection: "column",
});

export const topPerformersTitleStyle: SxProps<Theme> = {
  fontSize: "14px",
  fontWeight: 800,
  color: "text.primary",
  mb: 1,
};

export const topPerformersListStyle: SxProps<Theme> = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: 0.9,
};

export const topPerformerRowStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
};

export const topPerformerLeftStyle: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 0.85,
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
};

export const topPerformerRankStyle = (place: number): SxProps<Theme> => {
  if (place === 1) {
    return {
      width: 28,
      height: 28,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "12px",
      fontWeight: 800,
      color: "#FFFFFF",
      backgroundColor: "#F59E0B",
      flexShrink: 0,
    };
  }

  if (place === 2) {
    return {
      width: 28,
      height: 28,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "12px",
      fontWeight: 800,
      color: "#FFFFFF",
      backgroundColor: "#94A3B8",
      flexShrink: 0,
    };
  }

  if (place === 3) {
    return {
      width: 28,
      height: 28,
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "12px",
      fontWeight: 800,
      color: "#FFFFFF",
      backgroundColor: "#B45309",
      flexShrink: 0,
    };
  }

  return {
    width: 28,
    height: 28,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: 800,
    color: "#FFFFFF",
    backgroundColor: "#64748B",
    flexShrink: 0,
  };
};

export const topPerformerNameStyle: SxProps<Theme> = {
  fontSize: "13px",
  fontWeight: 700,
  color: "text.primary",
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const topPerformerScoreStyle: SxProps<Theme> = {
  fontSize: "12px",
  fontWeight: 700,
  color: "text.primary",
  whiteSpace: "nowrap",
  flexShrink: 0,
};

export const topPerformersEmptyStyle: SxProps<Theme> = {
  fontSize: "12px",
  color: "text.secondary",
};

export const topPerformersLinkStyle: SxProps<Theme> = {
  fontSize: "13px",
  fontWeight: 700,
  color: "#0EA5E9",
  mt: 0.75,
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: 0.35,
};
